import { connect } from 'react-redux'

import { getList, setItemState } from '../../../modules/notes'
import Component from './Schedule'

const mapActionCreators = {
  getList,
  setItemState,
}

const mapStateToProps = (state) => ({
  list: state.notes.get('list'),
  isFetching: state.notes.get('isFetching'),
  item: state.notes.get('item'),
})

export default connect(mapStateToProps, mapActionCreators)(Component)



// WEBPACK FOOTER //
// ./src/containers/schedule/list/index.js